export const ON_UPLOAD = "on_upload";
export const ON_SUBMIT_FILES_FAILED = "on_submit_files_failed";
export const ON_FILEUPLOAD_FINISHED = "on_fileupload_finished";
